import { Outlet } from 'react-router';
import { nav } from '@/testi';
import { Intestazione } from './Intestazione';

export { useUtenteArea } from './utente';

const voci = [
  { to: '/', testo: nav.percorso },
  { to: '/attestati', testo: nav.attestati },
  { to: '/profilo', testo: nav.profilo },
];

export function LayoutPartecipante() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Intestazione voci={voci} home="/" />
      <main id="contenuto" className="contenitore flex-1 py-8 md:py-12 flex flex-col gap-8">
        <Outlet />
      </main>
    </div>
  );
}
